import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class RoutingState {
  
  private history = [];

  constructor(
    private router: Router
  ) {}

  public loadRouting(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({urlAfterRedirects}: NavigationEnd) => {

        this.history = [...this.history, urlAfterRedirects];

      });
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] 
            || (this.history[this.history.length - 1].includes("autorizzazioni-e-comunicazioni") ? 
                '/pages/autorizzazioni-e-comunicazioni'
                : (this.history[this.history.length - 1].includes("gestione-autocertificazioni") ? 
                    '/pages/gestione-autocertificazioni'
                    :'/pages'
                    )
                );
  }

  public getPreviousUrlBack() {
    let backUrl = this.history[this.history.length - 2] 
    || (this.history[this.history.length - 1].includes("autorizzazioni-e-comunicazioni") ? 
        '/pages/autorizzazioni-e-comunicazioni'
        : (this.history[this.history.length - 1].includes("gestione-autocertificazioni") ? 
            '/pages/gestione-autocertificazioni'
            :'/pages'
            )
        );
    this.history.pop();
    this.history.pop();
    return backUrl;
  }

}